import React, { useEffect, useState } from "react";
import { Col, Row, Radio, Input, Checkbox, Form, Button } from "antd";
// import { getStyleProperties } from "../../../utils/CustomFunc";
import axios from "../../utils/BasicAuthAPI";
import "./exam.css";
import liracrypt from "../Liracrypt/liracrypt";

const Exam = (props) => {
  const onFinish = (values) => {
    let answer = { ...props.questions, minPassMarks: 5 };
    delete answer["questions"];
    delete answer["Data"];
    answer["answers"] = props.questions.questions.map((ques) => {
      
      return {
        ...ques,
        ans: "A",
        minPassMarks: 5,
        ansGiven:
          values[ques._id] && Array.isArray(values[ques._id])
            ? values[ques._id][0]
            : values[ques._id],
      };
    });

    if (props.submitHandler) {
      props.submitHandler(answer);
    }
  };

  
  return (
    <React.Fragment>
      <Row className="exam">
        {props.questions ? (
          <Col span={24} style={{ padding: "10px 10px" }}>
            <Row
              justify="space-between"
              style={{
                marginBottom: "20px",
                borderBottom: "1px solid #313452",
              }}
            >
              <Col span={8}>
                <p style={{ textAlign: "left", fontSize: "22px" }}>
                  Associate Name :{" "}
                  <span style={{ fontSize: "23px", fontWeight: "bold" }}>
                    {props.questions.eame}
                  </span>
                </p>
              </Col>
              <Col span={8}>
                <p style={{ textAlign: "center", fontSize: "22px" }}>
                  Skill Category :{" "}
                  <span style={{ fontSize: "23px", fontWeight: "bold" }}>
                    {props.questions["cat"]}
                  </span>
                </p>
              </Col>
              <Col span={8}>
                <p style={{ textAlign: "right", fontSize: "22px" }}>
                  Skill Level :{" "}
                  <span style={{ fontSize: "23px", fontWeight: "bold" }}>
                    {props.questions["lvl"]}
                  </span>
                </p>
              </Col>
            </Row>
          </Col>
        ) : null}
        <Form
          name="basic"
          initialValues={{ remember: true }}
          onFinish={onFinish}
        >
          {props.questions &&
          props.questions.Data &&
          Array.isArray(props.questions.Data) &&
          props.questions.Data.length > 0 ? (
            <React.Fragment>
              {props.questions.Data.map((question, ind) => (
                <Col
                  key={"qus" + ind}
                  span={24}
                  style={{ padding: "10px 10px" }}
                >
                  <p className="question">
                    {" "}
                    <span>Q {(ind + 1 < 10 ? "0" : "") + (ind + 1)}:</span>{" "}
                    {question.Qst}
                  </p>

                  {question.Typ !== "MULTI" ? (
                    <Form.Item
                      name={question._id}
                      rules={[
                        {
                          required: true,
                          message: "Please select a option",
                        },
                      ]}
                    >
                      <Radio.Group>
                        {question.option.map((opt, i) => (
                          <Radio key={"radio" + i} value={opt.key}>
                            {opt.value}
                          </Radio>
                        ))}
                      </Radio.Group>
                    </Form.Item>
                  ) : (
                    <Form.Item
                      name={question._id}
                      rules={[
                        {
                          required: true,
                          message: "Please select a option",
                        },
                      ]}
                    >
                      <Checkbox.Group>
                        {question.option.map((opt, i) => (
                          <Checkbox key={"check" + i} value={opt.key}>
                            {opt.value}
                          </Checkbox>
                        ))}
                      </Checkbox.Group>
                    </Form.Item>
                  )}
                </Col>
              ))}
              <div>hi</div>

              <Col>
                <Form.Item className="formBtnGroup" label=" " colon={false}>
                  <Button
                    type="primary"
                    htmlType="submit"
                    className="login-form-button gx-mt-1 bigBtn"
                  >
                    {"Submit"}
                  </Button>
                </Form.Item>
              </Col>
            </React.Fragment>
          ) : (
            <Col span={24} style={{ padding: "10px 10px" }}>
              <p style={{ textAlign: "center" }}>No Questions Available</p>
            </Col>
          )}
        </Form>
      </Row>
    </React.Fragment>
  );
};
export default Exam;
